module.exports = __webpack_public_path__ + "img/verify.8c3ad764.jpg";